import styled from 'styled-components';

export const ZenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  flex: 1;
`;

export const Focus = styled.div`
  height: 50%;
  width: 35%;
  min-height: 100px;
  min-width: 100px;
  margin: auto;
  position: relative;

  svg {
    height: 100%;
    width: 100%;
  }
`;
